import { RECORDS_FORM_TYPES } from "@/lib/form-categories";
import ManagerFormsIndex from "./forms.manager._index";

export default function RecordsIndex() {
  return (
    <ManagerFormsIndex
      formTypes={RECORDS_FORM_TYPES}
      pageTitle="Records"
      pageDescription="Review site reports, risk assessments, inspections, and incident records."
      detailBasePath="forms/records"
    />
  );
}
